module.exports = __webpack_public_path__ + "static/img/风门开关状态识别.5af27ce4.png";